import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { lazy, Suspense } from 'react';
import { EventsListSkeleton } from '@/components/events/EventsSkeletons';

const Events = lazy(() => import('@/pages/Events'));

const eventsSearchSchema = z.object({
  // Selected community/tier id. The sentinel '__global__' means "global
  // bucket — events with community_tier_id IS NULL". UUID otherwise.
  community: z.string().optional(),
  // List vs calendar view. Default 'list' is encoded by omission so the URL
  // stays clean for the most common case.
  view: z.enum(['list', 'calendar']).optional(),
});

export type EventsSearchParams = z.infer<typeof eventsSearchSchema>;

export const Route = createFileRoute('/events/')({
  validateSearch: (search) => eventsSearchSchema.parse(search),
  component: () => (
    // Layout-matched skeleton (not a spinner) so a slow chunk download and the
    // page's own data-fetch skeleton read as ONE continuous loading state.
    <Suspense fallback={<EventsListSkeleton />}>
      <Events />
    </Suspense>
  ),
});
